import { BaseEntity } from './base-entity.model';

export class Role extends BaseEntity {
    name: string;
    isAssessor: boolean;
    isEditor: boolean;
    isManager: boolean;
    isAnalyst: boolean;
    isAdmin: boolean;
    isReviewer: boolean;

    public get nameTranslationKey(): string {
        return 'USER.MESSAGES.ROLES.' + this.name.toUpperCase();
    }
}

export class
    User extends BaseEntity {
    id: number;
    firstName: string;
    lastName: string;
    username: string;
    email: string;
    expirationDate: Date;
    passwordNeedsChanging: boolean;
    roles: Role[] = [];
    password: string;
    checkPersonalData: boolean;

    projectValidationsEnabled = true;
    alwaysEnableProjectDelete = false;

    questionnaireValidationsEnabled = true;
    alwaysEnableQuestionnaireDelete = false;

    managerProgressbarEnabled = true;
    assessorProgressbarEnabled = true;
    reviewerProgressbarEnabled = true;

    assign(user: User, roles: Role[]) {
        this.username = user.username;
        this.firstName = user.firstName;
        this.lastName = user.lastName;
        this.email = user.email;
        this.roles = roles;

        this.alwaysEnableProjectDelete = user.alwaysEnableProjectDelete;
        this.alwaysEnableQuestionnaireDelete = user.alwaysEnableQuestionnaireDelete;

        this.projectValidationsEnabled = user.projectValidationsEnabled;
        this.questionnaireValidationsEnabled = user.questionnaireValidationsEnabled;

        this.managerProgressbarEnabled = user.managerProgressbarEnabled;
        this.assessorProgressbarEnabled = user.assessorProgressbarEnabled;
        this.reviewerProgressbarEnabled = user.reviewerProgressbarEnabled;
    }

    public get isAssessor(): boolean {
        return this.roles.find(r => r.isAssessor) !== undefined;
    }

    public get isManager(): boolean {
        return this.roles.find(r => r.isManager) !== undefined;
    }

    public get isEditor(): boolean {
        return this.roles.find(r => r.isEditor) !== undefined;
    }

    public get isAnalyst(): boolean {
        return this.roles.find(r => r.isAnalyst) !== undefined;
    }

    public get isAdministrator(): boolean {
        return this.roles.find(r => r.isAdmin) !== undefined;
    }

    public get isReviewer(): boolean {
        return this.roles.find(r => r.isReviewer) !== undefined;
    }

    public get fullname(): string {
        return this.lastName + ' ' + this.firstName;
    }

    public get rolesPlainText(): string {
        return this.roles.map(r => r.name).join(', ');
    }

    public get expired(): boolean {
        return this.expirationDate !== null && this.expirationDate <= new Date();
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/models/user.model.ts